import { Button, Container } from './styles';

type Props = {
  selected: string;
  setSelected: any;
}

const buttons = [
  { label: 'Snipz' },
  { label: 'Posts' },
  { label: 'Studio' },
  { label: 'Loja' },
  { label: 'Projetos' },
  { label: 'Coleção' },
]

export default function HorizontalMenu({ selected, setSelected }: Props) {
  return (
    <Container>
      {buttons.map((button, index) => (
        <Button key={index} selected={button.label === selected} onClick={() => setSelected(button.label)}>
          {button.label}
        </Button>
      ))}
    </Container>
  )
}